module.exports = __webpack_public_path__ + "static/frontUserNew/img/typeexl.d31a6260.svg";